import PropTypes from 'prop-types';

import { getQuestionTypeIcon, getQuestionTypeName } from '@helpers';
import { Pill } from '@utilities';

const QuestionTypePill = ({ question, ...props }) => {
  return (
    <Pill
      icon={getQuestionTypeIcon(question.type)}
      isCompleted
      value={getQuestionTypeName(question.type)}
      {...props}
    />
  );
};

QuestionTypePill.propTypes = {
  question: PropTypes.object.isRequired,
};

export default QuestionTypePill;
